import {createAction} from '@packages/utilities/create-action';
import type {Map} from 'immutable';
import type {AccessGroup, ActiveGroup} from './types';

export const SITE_USERS_SETTINGS_FETCHED = 'SITE_USERS_SETTINGS_FETCHED';

export const SITE_USERS_DISABLED_SUCCEEDED = 'SITE_USERS_DISABLED_SUCCEEDED';
export const SITE_USERS_DISABLED_FAILED = 'SITE_USERS_DISABLED_FAILED';
export const SITE_USERS_SETTINGS_FETCH_SUCCEEDED =
  'SITE_USERS_SETTINGS_FETCH_SUCCEEDED';
export const SITE_USERS_SETTINGS_FETCH_FAILED =
  'SITE_USERS_SETTINGS_FETCH_FAILED';
export const RESEND_EMAIL_VERIFICATION_REQUESTED =
  'RESEND_EMAIL_VERIFICATION_REQUESTED' as const;
export const RESEND_EMAIL_VERIFICATION_SUCCEEDED =
  'RESEND_EMAIL_VERIFICATION_SUCCEEDED' as const;
export const RESEND_EMAIL_VERIFICATION_FAILED =
  'RESEND_EMAIL_VERIFICATION_FAILED' as const;

export const SITE_ACCESS_GROUPS_FETCHED = 'SITE_ACCESS_GROUPS_FETCHED' as const;
export const SITE_ACCESS_GROUPS_FETCH_FAILED =
  'SITE_ACCESS_GROUPS_FETCH_FAILED' as const;
export const SITE_ACCESS_GROUPS_FETCH_SUCCEEDED =
  'SITE_ACCESS_GROUPS_FETCH_SUCCEEDED' as const;
export const ACCESS_GROUP_MINTED = 'ACCESS_GROUP_MINTED' as const;
export const ACCESS_GROUP_MODIFIED = 'ACCESS_GROUP_MODIFIED' as const;
export const ACCESS_GROUP_CREATED = 'ACCESS_GROUP_CREATED' as const;
export const ACCESS_GROUP_CREATE_FAILED = 'ACCESS_GROUP_CREATE_FAILED' as const;
export const ACCESS_GROUP_CREATE_SUCCEEDED =
  'ACCESS_GROUP_CREATE_SUCCEEDED' as const;
export const ACCESS_GROUP_MEMBERSHIP_PRODUCTS_LOADED =
  'ACCESS_GROUP_MEMBERSHIP_PRODUCTS_LOADED' as const;
export const DYN_ITEM_SAVED = 'DYN_ITEM_SAVED' as const;

type FetchSiteUsersSettingsAction = {
  type: typeof SITE_USERS_SETTINGS_FETCHED;
};

export type FetchSiteUsersSettingsSucceededAction = {
  type: typeof SITE_USERS_SETTINGS_FETCH_SUCCEEDED;
  response: any;
};

type SiteUsersDisabledFailedAction = {
  type: typeof SITE_USERS_DISABLED_FAILED;
};

type SiteUsersDisabledSucceededAction = {
  type: typeof SITE_USERS_DISABLED_SUCCEEDED;
  response: any;
};

type ResendUserEmailActionPayload = {
  siteShortName: string;
  userId: string;
  userEmail: string;
};

type ResendEmailVerificationAction = {
  type: typeof RESEND_EMAIL_VERIFICATION_REQUESTED;
  payload: ResendUserEmailActionPayload;
};

type FetchSiteAccessGroupsAction = {
  type: typeof SITE_ACCESS_GROUPS_FETCHED;
};

type FetchSiteAccessGroupsSucceededAction = {
  type: typeof SITE_ACCESS_GROUPS_FETCH_SUCCEEDED;
  response: any;
};

type AccessGroupMintedAction = {
  type: typeof ACCESS_GROUP_MINTED;
  mintGroup: ActiveGroup;
};

type AccessGroupModifiedAction = {
  type: typeof ACCESS_GROUP_MODIFIED;
  keyPath: string[];
  value: any;
};

type AccessGroupCreateSucceededAction = {
  type: typeof ACCESS_GROUP_CREATE_SUCCEEDED;
  response: {
    group: AccessGroup;
  };
};

type DynItemSavedAction = {
  type: typeof DYN_ITEM_SAVED;
  payload: {
    fromInline: boolean;
    itemSavingFinished: boolean;
    item: Map<string, string>;
  };
};

type AccessGroupMembershipProductsLoadedAction = {
  type: typeof ACCESS_GROUP_MEMBERSHIP_PRODUCTS_LOADED;
};

export const fetchSiteUsersSettings: () => FetchSiteUsersSettingsAction =
  createAction(SITE_USERS_SETTINGS_FETCHED);

export const siteUsersDisableSucceeded = ({
  response,
}: {
  response: any;
}): SiteUsersDisabledSucceededAction => ({
  type: SITE_USERS_DISABLED_SUCCEEDED,
  response,
});

export const siteUsersDisableFailed: () => SiteUsersDisabledFailedAction =
  createAction(SITE_USERS_DISABLED_FAILED);

export const resendEmailVerification: (
  value: ResendUserEmailActionPayload
) => ResendEmailVerificationAction = createAction(
  RESEND_EMAIL_VERIFICATION_REQUESTED
);

export const fetchSiteAccessGroups: () => FetchSiteAccessGroupsAction =
  createAction(SITE_ACCESS_GROUPS_FETCHED);

export type SiteUserAction =
  | FetchSiteUsersSettingsAction
  | FetchSiteUsersSettingsSucceededAction
  | SiteUsersDisabledSucceededAction;

export type SiteAccessGroupAction =
  | FetchSiteAccessGroupsAction
  | FetchSiteAccessGroupsSucceededAction
  | AccessGroupMintedAction
  | AccessGroupModifiedAction
  | AccessGroupCreateSucceededAction
  | AccessGroupMembershipProductsLoadedAction
  | DynItemSavedAction;
